import { MapConfig } from '@kinetic-ui/data-layer';
import { LineString } from '@turf/helpers';

export type BoundsMapConfig = Omit<MapConfig, 'zoom'> & {
  geometry: LineString;
};

export const isBoundsMapConfig = (config?: MapConfig | null): config is BoundsMapConfig => {
  return config?.geometry?.type === 'LineString';
};
